








import settings from '@/settings.coffee'
import gql from '@/gqlService.coffee'
import Message from '@/components/Message'

export default {
    "name": "MessageList"
    "components": {Message}
    "props": {}
    "computed":{}
    "data":()->
        {
            "messages": new gql.DataHolder({
                "model": "alert_set",
                "fields": "uid text title read created_on"
                "autoload": true,
                "filters": "to__uid: \"#{this.$store.state.profile.data.uid}\""
            })
        }
}
